import axios from 'axios';
import { PRICE_MANAGER_ENDPOINT } from '@dynameat/constants';

export const getFrontPriceListRequest = (saleRateGuid, startDate, endDate) => axios.get(PRICE_MANAGER_ENDPOINT(saleRateGuid), { params: { start_date: startDate, end_date: endDate } });
export const updateFrontPriceListRequest = (priceListToUpdate) => axios.post(PRICE_MANAGER_ENDPOINT(), priceListToUpdate);
